import type { VendingMachineLocation } from '~/contracts/vm';
import { LeftImage, SplitContent } from './SplitHero.styles';
import MapFinder from '../MapSection/MapFinder';

const noop = () => {};

type OwnProps = {
  vendingMachine: VendingMachineLocation;
  vendingMachineLocations: VendingMachineLocation[];
};

export default function SplitHero({
  vendingMachine,
  vendingMachineLocations
}: OwnProps) {
  return (
    <SplitContent>
      <LeftImage />
      <div>
        <MapFinder
          isNationwide={false}
          currentZip=""
          hasLegend={false}
          defaultLocation={vendingMachine}
          vendingMachineLocations={vendingMachineLocations}
          setGeoCoords={noop}
          onSubmit={noop}
          onZipChange={noop}
        />
      </div>
    </SplitContent>
  );
}
